import { Dispatch, SetStateAction, useEffect, useState } from "react";

const usePersistedState = <T>(
  key: string,
  initialValue: T,
): [T, Dispatch<SetStateAction<T>>, boolean] => {
  const [state, setState] = useState<T>(initialValue);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- localStorage may only be read after hydration, and consumers rely on isHydrated flipping together with the loaded value
    setIsHydrated(true);
    try {
      const item = localStorage.getItem(key);
      if (item) {
        const parsedState = JSON.parse(item).state;
        if (parsedState !== undefined) {
          setState(parsedState);
        }
      }
    } catch (e) {
      // nothing to do here
    }
  }, [key]);

  useEffect(() => {
    if (!isHydrated) return;

    try {
      if (state === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify({ state }));
      }
    } catch (e) {
      // nothing to do here
    }
  }, [state, key, isHydrated]);

  return [state, setState, isHydrated];
};

export default usePersistedState;
